import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

interface CardProps {
  isActive?: boolean;
}

export const CardRoot = styled("div")(({ isActive }: CardProps) => ({
  padding: 16,
  border: `1px solid ${isActive ? colors.brandBlue600 : colors.gray200}`,
  width: "100%",
  borderRadius: 12,
  cursor: "pointer",
}));

export const Content = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const Subtitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: 0.25,
  color: colors.gray600,
}));

export const Title = styled("span")(({ isActive }: CardProps) => ({
  fontFamily: "Manrope",
  fontSize: 22,
  fontWeight: 600,
  lineHeight: "28px",
  color: isActive ? colors.brandBlue600 : colors.gray600,
}));
